/**
 * PORT-7
 * Нет возможности прокрутки меню "on this page"
 * Респонзив правого бара
 * Блок: Правое меню
 * Раздел: Документация
 * На страницах с большим объёмом контента (например - UG Настройка фабрик/Настройка VXLAN) меню "on this page" не помещается на экране целиком, и не получается его прокрутить, чтобы увидеть оставшуюся часть.
 **/
import "./right_sidebar.css"
import {route_parse, logError} from "../function.js";

export function right_side_bar_size() {
    try {
        var $sidebar = $("#right-sidebar");
        if (!$sidebar.length) return;
        if (document.body.offsetWidth > 1260) {
            $sidebar.children("div").css("width", $sidebar.width() + "px")
            const left = $sidebar.offset().left;
            $sidebar.children("div").css("left", left + 20 + "px")
        }
    } catch (e) {
        logError(e)
    }

}

let active_hash

$(document).ready(function () {
    var $sidebar = $("#right-sidebar");
    if (!$sidebar.length) return;
    var $sidebarDiv = $sidebar.children("div");

    try {

        $(window).resize(function () {
            right_side_bar_size()
        });
        right_side_bar_size()
        $('#right-sidebar a.reference').click(function (e, d) {
            try {
                e.preventDefault();
                const hash = $(this).attr("href")
                if (hash == "#") {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 500); // 500 мс -0 время анимации
                    history.pushState(null, null, `${window.location.origin}${window.location.pathname}`);
                    return false;
                }
                const target = $("#block-main").find(`a[href="${hash}"]`)
                var scrollY = target.offset().top - 60;
                $('html, body').animate({
                    scrollTop: scrollY
                }, 500); // 500 мс - время анимации
                history.pushState(null, null, hash);
            } catch (e) {
                logError(e)
            }
        });
        /**
         * скрытие шагов
         */

        $('#right-sidebar a.reference').each(function (k, e) {
            try {
                const text = $(this).text()
                if (isStep(text)) {
                    $(this).closest("li").addClass("hidest")
                }
            } catch (e) {
                logError(e)
            }
        })
        const route = route_parse()
        $('#right-sidebar a.reference').each(function (k, e) {
            try {
                /**
                 * скрытие последнего уровня для cr
                 */
                if (route[4] === "aqnos_cr_ru" || route[4] === "aqnos_cr_en") {
                    let children = $(this).closest("ul").find("ul")
                    if (children.length == 0) {
                        $(this).closest("li").addClass("hidest")
                    }

                }
            } catch (e) {
                logError(e)
            }
        })

        function isStep(text) {
            try {
                const regex_en = /^(step|Step).*?$/; // Пример регулярного выражения (только буквы и цифры)
                const regex_ru = /^(шаг|Шаг).*?$/; // Пример регулярного выражения (только буквы и цифры)
                if (regex_en.test(text) || regex_ru.test(text)) {
                    return true
                }
                return false
            } catch (e) {
                logError(e)
            }
        }

        $sidebarDiv.find(">div>div>ul>li>ul>li>ul").show()
        /**
         * массив якорей для прокрутки
         * @type {*[]}
         */
        const arr_hash = []
        const arr_text = []
        $('#right-sidebar a.reference').each(function (k, e) {
            try {
                const hash = $(this).attr('href');
                const text = $(this).text();
                if (!$(this).closest('li').hasClass('hidest')) {
                    arr_hash.push(hash)
                    arr_text.push(text)
                }
            } catch (e) {
                logError(e)
            }

        })

        $(window).scroll(function () {
            right_scroll()
        });
        right_scroll();

        function right_scroll() {
            try {

                // return false
                const scrollTop = $(window).scrollTop();
                right_side_bar_size()
                $('#right-sidebar a.reference').removeClass("active")
                let ind = false;

                arr_hash.map((hash, key) => {
                    try {
                        if (hash == "#") return true;
                        if (ind) return true
                        const targetElement = $("#block-main").find(`a[href="${hash}"]`)
                        let top = targetElement.offset().top - 70
                        let bottom = targetElement.offset().top + targetElement.height()
                        if (top <= $(window).scrollTop() + $(window).height() && bottom >= $(window).scrollTop()) {
                            if (isStep(arr_text[key])) {
                                return true
                            }
                            active_hash = $(`a[href="${hash}"]`)
                            active_hash.addClass('active');
                            ind = true
                        } else {
                            if (active_hash !== undefined)
                                active_hash.addClass('active');
                        }
                    } catch (e) {
                        logError(e)
                    }
                })


                // фиксация меню
                if (document.body.offsetWidth < 1260) return false;
                if (scrollTop >= $(".header__top").outerHeight() + 50) {
                    $sidebarDiv.addClass("right_bar_fix");
                    var blockHeight = $(document).height() - scrollTop - $('.footer').outerHeight() - 80;
                    $sidebarDiv.css("max-height", blockHeight + "px")
                } else {
                    $sidebarDiv.removeClass("right_bar_fix");
                    $sidebarDiv.css("max-height", "none")
                }
            } catch (e) {
                logError(e)
            }
        }


        $sidebarDiv.children("div").prepend(
            `
           <div class="menu__header secondary d-flex align-center justify-space-between"> 
           <div class="menu__prev link link--white">
           <i aria-hidden="true" class="v-icon notranslate ci ci-chevron_big_left theme--light" style="font-size:24px"></i>
           </div> 
           <div class="menu__title text-body-1 white--text fw-500">Меню</div> 
               <div id="mm_close_right_sidebar" class="link link--white"> 
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                        <path d="M21 21L3 3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M21.0001 3L3 21.0001" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> 
                    </svg> 
               </div> 
           </div>
    `);
        if (window.config.auth.id_category == 1) {
            try {
                $sidebarDiv.addClass("admin")
            } catch (e) {
                logError(e)
            }
        }
        $('#toggle_right_sidebar').click(function (e, d) {
            try {
                if ($sidebarDiv.children("div").children("div").text().trim() == "Меню") return false;
                $sidebarDiv.addClass("open")
            } catch (e) {
                logError(e)
            }
        })
        $('#mm_close_right_sidebar').click(function (e, d) {
            try {
                $sidebarDiv.removeClass("open")
            } catch (e) {
                logError(e)
            }
        })

        if ($sidebarDiv.children("div").children("div").text().trim() == "Меню") {
            try {
                $(".btn_toggle_right_sidebar").addClass("disable")
            } catch (e) {
                logError(e)
            }
        }

        // PORT-124
        $('#block-main a.headerlink').click(function (e, d) {
            try {
                // alert($(this).attr("href"))
                const hash = $(this).attr("href")
                const target = $("#block-main").find(`a[href="${hash}"]`)
                var scrollY = target.offset().top - 70;

                $('html, body').animate({
                    scrollTop: scrollY
                }, 500); // 500 мс - время анимации
            } catch (e) {
                logError(e)
            }
        })

        const hash = window.location.hash;

        if (hash) {
            // Убираем символ '#', чтобы использовать как селектор
            const target = $(hash);

            if (target.length) {
                const scrollY = target.offset().top - 70; // 70 — отступ под хедер
                $('html, body').animate({
                    scrollTop: scrollY
                }, 500); // 500 мс — длительность анимации
            }
        }
    } catch (e) {
        logError(e)
    }
});


